import React from "react";
import { Box, TextField, useMediaQuery, useTheme } from "@mui/material";

const getTextAreaStyles = (hasContent) => ({
    width: "100%",
    minHeight: "200px",
    height: "100%",
    borderRadius: "16px",
    "& .MuiOutlinedInput-root": {
        height: "100%",
        minHeight: "200px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        borderRadius: "16px",
        backgroundColor: hasContent
            ? "rgba(255, 255, 255, 0.3)"
            : "rgba(255, 255, 255, 0.2)",
        border: "2px dashed",
        borderColor: hasContent ? '#0017E7' : '#D9D9D9',
        transition: "all 0.3s ease",
        fontFamily: "Poppins",
        "&:hover": {
            transform: "translateY(-4px)",
            backgroundColor: "rgba(255, 255, 255, 0.35)",
            borderColor: '#0017E7',
        },
        "&.Mui-focused": {
            backgroundColor: "rgba(255, 255, 255, 0.35)",
            borderColor: '#0017E7',
            transform: "translateY(-4px)",
        },
        "&.Mui-disabled": {
            backgroundColor: "#f5f5f5",
            borderColor: "#e0e0e0",
        },
        "& fieldset": {
            border: "none",
        },
        "& textarea": {
            minHeight: "20px",
            color: hasContent ? "#0017E7" : "#9e9e9e",
            fontFamily: "Poppins",
            fontSize: "14px",
            "&::placeholder": {
                color: "#9e9e9e",
                opacity: 0.7,
            },
        },
    },
});

const CoverLetterTextArea = ({ value, onChange, placeholder, disabled }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const hasContent = value && value.trim().length > 0;

    const handleChange = (event) => {
        console.log('CoverLetterTextArea onChange triggered:', event.target.value);
        if (onChange) {
            onChange(event);
        }
    };

    return (
        <Box sx={{ width: "100%" }}>
            <TextField
                multiline
                rows={isMobile ? 6 : 8}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                disabled={disabled}
                variant="outlined"
                fullWidth
                sx={getTextAreaStyles(hasContent)}
            />
        </Box>
    );
};

export default CoverLetterTextArea;
